import requestUtils from "../request_util";
import store from "@/store";
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '../constant.js';
export default {
    //直接打开绑定邮箱弹窗
    openBindEmailPage(dirction,item,paySource){
        dirction.$refs.bindEmailJumpDialog.touristPurchase = true;
        dirction.$refs.bindEmailJumpDialog.bindEmailFlag = false;
        dirction.$refs.bindEmailJumpDialog.bindEmailShow = true;
        dirction.$refs.bindEmailJumpDialog.item=item;
        dirction.$refs.bindEmailJumpDialog.paySource=paySource;
    }
}


// WEBPACK FOOTER //
// ./src/js/workspace/pay_system_util.js